/**
 * These generate a new phaseTask component based on the
 * slugs for the tasks.
 * The base component for these is located here:
 * client/app/screens/main/screens/phases/phaseShow/components/tasks/phase_task.jsx
 *
 * GenericOneClickTask simply overrides the onClick event for
 * PhaseTask.
 *
 * The component that calls GenericOneClickTasks to generate a
 * task that can be advanced by clicking is here:
 * client/app/screens/main/screens/phases/phaseShow/components/phaseTasks.jsx
 * */

import PhaseTask from './phase_task';
import { connect } from 'react-redux';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';

export class GenericOneClick extends PhaseTask {
  onClick = () => {
    this.completeTask();
  }
}

const generic_one_click = connect(() => ({}),
  { updatePhaseTask, clearValidationErrors })(GenericOneClick);

export {
  generic_one_click as start_contract_verification,
  generic_one_click as installer_paysheet_attached,
  generic_one_click as review_assessment,
  generic_one_click as refigure_assessment,
  generic_one_click as arrived_at_appointment,
  generic_one_click as measuring_en_route,
  generic_one_click as installing_en_route,
  generic_one_click as workorder_en_route,
  generic_one_click as workorder_arrived,
  generic_one_click as workorder_departed,
  generic_one_click as arrived,
  generic_one_click as install_send_to_scheduling,
  generic_one_click as workorder_send_to_scheduling,
  generic_one_click as assessment_send_to_scheduling,
  generic_one_click as check_into_store,
  generic_one_click as driver_dispatch,
  generic_one_click as driver_arrived,
};



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/generic_one_click.jsx